/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_Move_DownInputs */

const en_admin_questionnaire_editor_move_down = /** @type {(inputs: Admin_Questionnaire_Editor_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move down`)
};

const nl_admin_questionnaire_editor_move_down = /** @type {(inputs: Admin_Questionnaire_Editor_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omlaag`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_Move_DownInputs) => LocalizedString} */
const de_admin_questionnaire_editor_move_down = en_admin_questionnaire_editor_move_down;

/** @type {(inputs: Admin_Questionnaire_Editor_Move_DownInputs) => LocalizedString} */
const es_admin_questionnaire_editor_move_down = en_admin_questionnaire_editor_move_down;

/** @type {(inputs: Admin_Questionnaire_Editor_Move_DownInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_move_down = en_admin_questionnaire_editor_move_down;

/** @type {(inputs: Admin_Questionnaire_Editor_Move_DownInputs) => LocalizedString} */
const it_admin_questionnaire_editor_move_down = en_admin_questionnaire_editor_move_down;

/** @type {(inputs: Admin_Questionnaire_Editor_Move_DownInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_move_down = en_admin_questionnaire_editor_move_down;

/** @type {(inputs: Admin_Questionnaire_Editor_Move_DownInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_move_down = en_admin_questionnaire_editor_move_down;

/** @type {(inputs: Admin_Questionnaire_Editor_Move_DownInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_move_down = en_admin_questionnaire_editor_move_down;

/** @type {(inputs: Admin_Questionnaire_Editor_Move_DownInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_move_down = en_admin_questionnaire_editor_move_down;

/**
* | output |
* | --- |
* | "Move down" |
*
* @param {Admin_Questionnaire_Editor_Move_DownInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_move_down = /** @type {((inputs?: Admin_Questionnaire_Editor_Move_DownInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_Move_DownInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_move_down(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_move_down(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_move_down(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_move_down(inputs)
	if (locale === "nl") return nl_admin_questionnaire_editor_move_down(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_move_down(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_move_down(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_move_down(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_move_down(inputs)
	return ro_admin_questionnaire_editor_move_down(inputs)
});
export { admin_questionnaire_editor_move_down as "admin.questionnaire_editor.move_down" }